// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2lF3h","text":"SelectPayment_text__3CrQA","title":"SelectPayment_title__3Lqq8","btn":"SelectPayment_btn__3zHUd"};